import { Injectable } from '@angular/core';
import {ServiceModule} from "../../../service.module";

@Injectable({
    providedIn: ServiceModule
})
export class PdfService {
    pdfMake: any;

    async loadPdfMaker() {
        if (!this.pdfMake) {
            const pdfMakeModule = await import("pdfmake/build/pdfmake");
            const pdfFontsModule = await import("pdfmake/build/vfs_fonts");

            // @ts-ignore
            this.pdfMake = pdfMakeModule.default;
            // @ts-ignore
            this.pdfMake.vfs = pdfFontsModule.default;
        }
    }

    async generatePdf(def: any) {
        await this.loadPdfMaker();
        return this.pdfMake.createPdf(def);
    }

    getBlobPromise(pdfItem: any) {
        return new Promise((resolve, reject) => {
            pdfItem.getBlob((blob: any) => {
                if (blob) {
                    resolve(blob);
                } else {
                    reject(new Error('Failed to get blob'));
                }
            });
        });
    }

    downloadPdf(pdf: any, fileName: string) {
        pdf.download(fileName);
    }
}
